import React from "react";
import SummaryHeader from "../atoms/SummaryHeader";
import SummaryContainer from "../organisms/SummaryContainer";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {summaryAction} from "../../../redux/store";
import useScrollHeaderOpacity from "../../../hooks/core/useScrollHeaderOpacity";

const Summary = () => {

  const {connectMode} = useSelector(state => ({
    connectMode: state.theme.connectMode,
  }), shallowEqual);

  const dispatch = useDispatch();
  const { innerRef, bodyRef, containerRef, isHeaderOpaque} = useScrollHeaderOpacity();




  const runSummaryAnimation = () => {
    if (connectMode !== "web") {
      return;
    }

    dispatch(summaryAction.setRunningSummaryAnimation(true));
    window && window.postMessage({msg: "summaryAnimation:run", data: Number(0.2)});

    const stopSummaryEventLister = (event) => {
      if (event.data === "summaryAnimation:stop") {
        dispatch(summaryAction.setRunningSummaryAnimation(false));
        window.removeEventListener("message", stopSummaryEventLister);
      }
    }
    window.addEventListener("message", stopSummaryEventLister);
  }




  return (
    <div ref={containerRef} className={`summary`} id={"summary"}>

        <SummaryHeader
          headerOpacity={isHeaderOpaque}
        />
        <SummaryContainer bodyRef={bodyRef} innerRef={innerRef} runSummaryAnimation={runSummaryAnimation} />

    </div>
  )
}
export default Summary
